var _path, _path2, _path3, _circle, _circle2, _circle3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRefToOrderly = function SvgRefToOrderly(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00C6A2",
    d: "M30 0h-6.363L30 6.364V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#RefToOrderly_svg__a)",
    fillRule: "evenodd",
    d: "M9.999 1.818h8.182V9.37l-4.512 4.19-3.67-3.67V1.818Zm3.6 15.53 4.582-4.255v16.906H9.999V13.748l3.6 3.6Zm5.487 1.731a8.636 8.636 0 0 0 7.426-13.724l-7.426 6.896v6.828Zm0-10.55 5.487-5.094a8.597 8.597 0 0 0-5.487-1.605v6.7ZM9.091 1.82H0v11.706l6.817-6.817L9.09 8.982V1.82Zm0 11.02-2.274-2.274L0 17.382V30h9.09V12.84ZM30 30H19.09V19.09L30 30Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#RefToOrderly_svg__b)",
    fillRule: "evenodd",
    d: "M100.364 20.48C98.427 27.136 92.281 32 85 32c-7.281 0-13.427-4.864-15.364-11.52h9.933A7.026 7.026 0 0 0 85 23.04c2.186 0 4.14-.996 5.43-2.56h9.934Zm.316-1.28h-9.408a7.01 7.01 0 0 0 .768-3.2 7.01 7.01 0 0 0-.768-3.2h9.408c.21 1.034.32 2.104.32 3.2s-.11 2.166-.32 3.2Zm-21.952 0a7.01 7.01 0 0 1-.768-3.2c0-1.152.277-2.24.767-3.2H69.32A16.078 16.078 0 0 0 69 16c0 1.096.11 2.166.32 3.2h9.408ZM72.199 6.4a15.945 15.945 0 0 0-2.563 5.12h9.933A7.026 7.026 0 0 1 85 8.96c2.186 0 4.14.996 5.431 2.56h9.933a15.936 15.936 0 0 0-2.563-5.12H72.199Zm24.532-1.28H73.269A15.957 15.957 0 0 1 85 0c4.635 0 8.809 1.97 11.731 5.12Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 17.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 17.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 17.5,
    r: 1.5,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "RefToOrderly_svg__a",
    x1: 14.089,
    x2: 14.089,
    y1: 1.818,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "RefToOrderly_svg__b",
    x1: 85,
    x2: 85,
    y1: 0,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgRefToOrderly;